"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanFeatureId = exports.SubscriptionStatus = exports.PaymentStatus = exports.ContractStatus = exports.DiscountDuration = exports.PaymentMethod = exports.PlanRecurrence = exports.PlanProvider = exports.SubscriptionDiscountPeriod = void 0;
var SubscriptionDiscountPeriod;
(function (SubscriptionDiscountPeriod) {
    SubscriptionDiscountPeriod["Days"] = "DAYS";
    SubscriptionDiscountPeriod["Weeks"] = "WEEKS";
    SubscriptionDiscountPeriod["Months"] = "MONTHS";
    SubscriptionDiscountPeriod["Years"] = "YEARS";
})(SubscriptionDiscountPeriod || (exports.SubscriptionDiscountPeriod = SubscriptionDiscountPeriod = {}));
var PlanProvider;
(function (PlanProvider) {
    PlanProvider["Apple"] = "APPLE";
    PlanProvider["Google"] = "GOOGLE";
    PlanProvider["RediRedi"] = "REDIREDI";
    PlanProvider["Stripe"] = "STRIPE";
    PlanProvider["PagarMe"] = "PAGARME";
})(PlanProvider || (exports.PlanProvider = PlanProvider = {}));
var PlanRecurrence;
(function (PlanRecurrence) {
    PlanRecurrence["Monthly"] = "MONTHLY";
    PlanRecurrence["Quarterly"] = "QUARTERLY";
    PlanRecurrence["Annual"] = "ANNUAL";
    PlanRecurrence["Lifetime"] = "LIFETIME";
    PlanRecurrence["NotApply"] = "NOT_APPLY";
})(PlanRecurrence || (exports.PlanRecurrence = PlanRecurrence = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CreditCard"] = "CREDIT_CARD";
    PaymentMethod["Boleto"] = "BOLETO";
    PaymentMethod["Pix"] = "PIX";
    PaymentMethod["DebitCard"] = "DEBIT_CARD";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var DiscountDuration;
(function (DiscountDuration) {
    DiscountDuration["Forever"] = "FOREVER";
    DiscountDuration["Once"] = "ONCE";
    DiscountDuration["Repeating"] = "REPEATING";
})(DiscountDuration || (exports.DiscountDuration = DiscountDuration = {}));
var ContractStatus;
(function (ContractStatus) {
    ContractStatus["Cancelled"] = "CANCELLED";
    ContractStatus["Pending"] = "PENDING";
    ContractStatus["Active"] = "ACTIVE";
    ContractStatus["Overdue"] = "OVERDUE";
    ContractStatus["Trial"] = "TRIAL";
    ContractStatus["TrialExpired"] = "TRIAL_EXPIRED";
    ContractStatus["Churn"] = "CHURN";
    ContractStatus["Expired"] = "EXPIRED";
    ContractStatus["Upgraded"] = "UPGRADED";
    ContractStatus["Downgraded"] = "DOWNGRADED";
})(ContractStatus || (exports.ContractStatus = ContractStatus = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Paid"] = "PAID";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Pending"] = "PENDING";
    PaymentStatus["NotCharged"] = "NOT_CHARGED";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["PaymentRequired"] = "PAYMENT_REQUIRED";
    SubscriptionStatus["CanceledActive"] = "CANCELED_ACTIVE";
    SubscriptionStatus["CanceledInactive"] = "CANCELED_INACTIVE";
    SubscriptionStatus["Trial"] = "TRIAL";
    SubscriptionStatus["TrialEnded"] = "TRIAL_ENDED";
    SubscriptionStatus["Ok"] = "OK";
    SubscriptionStatus["Unhandled"] = "UNHANDLED";
})(SubscriptionStatus || (exports.SubscriptionStatus = SubscriptionStatus = {}));
/**
 * @description For more information about each feature, check: https://www.notion.so/Freemium-MVP-5fda4c2d0cf1422fb36e2a12d3a67d7a
 */
var PlanFeatureId;
(function (PlanFeatureId) {
    /**
     * OpenAI usage over our features (i.e. product description, product title for promotion, etc).
     */
    PlanFeatureId["OpenAiAssistant"] = "inventory.openai";
    /**
     * Access to special promotion templates.
     */
    PlanFeatureId["SpecialPromotionTemplates"] = "promotion.special-templates";
    /**
     * Activation of promotions over the store.
     */
    PlanFeatureId["PromotionsActivation"] = "promotion.promotions-activation";
    /**
     * Promotional coupons for the store.
     */
    PlanFeatureId["PromotionCouponsActivation"] = "promotion.coupons-activation";
    /**
     * Promotional videos for the store.
     */
    PlanFeatureId["PromotionVideosActivation"] = "promotion.videos-activation";
    /**
     * Amount of items that are allowed to be created
     */
    PlanFeatureId["Items"] = "inventory.items";
    /**
     * Amount of pictures per item that are allowed to be uploaded.
     */
    PlanFeatureId["ItemPictures"] = "inventory.item-pictures";
    /**
     * Item spotlight.
     */
    PlanFeatureId["ItemSpotlight"] = "inventory.item-spotlight";
    /**
     * Amount of items from catalog search that can be created.
     */
    PlanFeatureId["CatalogBasedItems"] = "inventory.catalog-based-items";
    /**
     * App reports.
     */
    PlanFeatureId["Reports"] = "report.reports";
    /**
     * Amount of order notification allowed to be sent on WhatsApp.
     */
    PlanFeatureId["WhatsAppOrderNotification"] = "notification.orders-whatsapp";
    /**
     * Amount of order notification allowed to be sent on email.
     */
    PlanFeatureId["EmailOrderNotification"] = "notification.orders-email";
    /**
     * Special storefront customization.
     */
    PlanFeatureId["CatalogCustomization"] = "store.storefront-customization";
    /**
     * Amount of categories that are allowed to be created.
     */
    PlanFeatureId["CustomItemCategories"] = "inventory.custom-categories";
    /**
     * Item variation.
     */
    PlanFeatureId["ItemVariation"] = "inventory.item-variation";
    /**
     * Price per variation.
     */
    PlanFeatureId["ItemPricePerVariation"] = "inventory.price-variation";
    /**
     * The Storefront advertising
     */
    PlanFeatureId["StorefrontAdvertising"] = "storefront.advertising";
    /**
     * Report over storefront visits.
     */
    PlanFeatureId["StorefrontVisitsReport"] = "report.storefront-visits-report";
    /**
     * Storefront sessions per month.
     */
    PlanFeatureId["StorefrontSessions"] = "storefront.sessions";
    /**
     * Edition of orders.
     */
    PlanFeatureId["OrderEdition"] = "order.order-edition";
    /**
     * Item competitive price analysis.
     */
    PlanFeatureId["ItemCompetitivePrice"] = "inventory.competitive-price";
    /**
     * Item stock insights (items with no pictures, under stock, etc).
     */
    PlanFeatureId["ItemStockInsights"] = "inventory.stock-insights";
    /**
     * Item import from a spreadsheet.
     */
    PlanFeatureId["ItemImportSpreadsheet"] = "inventory.import-spreadsheet";
    /**
     * Order shipment label.
     */
    PlanFeatureId["OrderShipmentLabel"] = "order.shipment-label";
    /**
     * Channel connections for the store.
     */
    PlanFeatureId["StoreChannelsIntegration"] = "store.channels-integration";
    /**
     * Integration of orders over channels.
     */
    PlanFeatureId["OrderChannelsIntegration"] = "order.channels-integration";
    /**
     * Integration of stock over channels.
     */
    PlanFeatureId["StockChannelsIntegration"] = "inventory.channels-integration";
    /**
     * Custom domain for the storefront.
     */
    PlanFeatureId["CatalogCustomDomain"] = "store.storefront-custom-domain";
    /**
     * @deprecated Use `store.external-analytics-integration` instead.
     */
    PlanFeatureId["GoogleAnalyticsMetaPixelIntegration"] = "store.google-analytics-meta-pixel-integration";
    /**
     * Possibility to set other analytics providers outside of RediRedi.
     */
    PlanFeatureId["ExternalAnalyticsIntegration"] = "store.external-analytics-integration";
    /**
     * Store support.
     */
    PlanFeatureId["StoreSupport"] = "store.support";
    /**
     * Allows stores to create and manage their salespeople on RediRedi.
     */
    PlanFeatureId["StoreSalespeople"] = "store.salespeople";
    /**
     * Customers management.
     */
    PlanFeatureId["OrderCustomer"] = "order.customers";
    /**
     * Number of interactions with RediRedi AI that are allowed to be use.
     */
    PlanFeatureId["RediInteractions"] = "redi.interactions";
    /**
     * Business opportunity analysis for store customers.
     */
    PlanFeatureId["OrderOpportunityAnalysis"] = "order.orders-opportunity-analysis";
})(PlanFeatureId || (exports.PlanFeatureId = PlanFeatureId = {}));
//# sourceMappingURL=plan.js.map